import { LiveDraft, liveUtteranceText } from './live-transcript-state.ts';
import {
  LiveSection,
  LiveSectionDetail
} from '../types/editors/live-section.ts';

export const sectionRows = (
  rows: LiveDraft[],
  section: LiveSection
): LiveDraft[] =>
  rows.filter(
    row =>
      row.segment.sequence >= section.start_sequence &&
      row.segment.sequence <= section.end_sequence
  );

export const frozenSectionRows = (section: LiveSectionDetail): LiveDraft[] =>
  section.document.document.map((utterance, index) => ({
    segment: {
      segment_id: utterance.segment_id || `${section.section_id}:${index}`,
      sequence: section.start_sequence + index,
      revision: utterance.segment_revision ?? 0,
      machine_text: liveUtteranceText(utterance),
      utterance
    },
    dirty: false,
    editVersion: 0
  }));
